const handleTabsClick = (clickedTab, otherTab, beforeImage, afterImage) => {
    if (clickedTab.classList.contains('active-tab')) {
        return;
    } else {
        if (beforeImage.classList.contains('active-image')) {
            beforeImage.classList.remove('active-image');
            afterImage.classList.add('active-image');
        } else {
            afterImage.classList.remove('active-image');
            beforeImage.classList.add('active-image');
        }

        clickedTab.classList.add('active-tab');
        otherTab.classList.remove('active-tab');
    }
}

const handleProjectHighlightTabs = (container) => {
    const beforeImage = container.querySelector('.project-highlight__tab--before-image');
    const afterImage = container.querySelector('.project-highlight__tab--after-image');
    const beforeTab = container.querySelector('.project-highlight__tab--tabs-before');
    const afterTab = container.querySelector('.project-highlight__tab--tabs-after');

    beforeTab.addEventListener("click", (e) => handleTabsClick(beforeTab, afterTab, beforeImage, afterImage));
    afterTab.addEventListener("click", (e) => handleTabsClick(afterTab, beforeTab, beforeImage, afterImage));
}

export default handleProjectHighlightTabs;